import { RootState } from "../../rootReducer";

export const selectIsLoadingBreakfast = (state: RootState) =>
  state.breakfast.loading;
export const breakfastErrorMessage = (state: RootState) =>
  state.breakfast.error;
export const breakfastDataResponse = (state: RootState) =>
  state.breakfast.breakfastResponse;
